const categories = [
  {
    id: 1,
    title: 'iPhone Kılıfları',
    subtitle: 'En yeni modeller için',
    tag: 'Çok Satan',
    tagColor: 'bg-[#FF4500]',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20premium%20iPhone%20cases%20in%20various%20colors%20and%20designs%20displayed%20on%20clean%20white%20surface%2C%20modern%20minimalist%20product%20photography%2C%20bold%20colors%20orange%20black%20and%20transparent%20cases%2C%20professional%20retail%20display&width=600&height=700&seq=cat001&orientation=portrait',
    icon: 'ri-smartphone-line',
  },
  {
    id: 2,
    title: 'Kişiye Özel Baskı',
    subtitle: 'Sen tasarla, biz yapalım',
    tag: 'Trend',
    tagColor: 'bg-[#FF4500]',
    image: 'https://readdy.ai/api/search-image?query=custom%20printed%20phone%20case%20with%20personal%20photo%20printing%20process%2C%20colorful%20vibrant%20custom%20design%20phone%20case%20close%20up%2C%20professional%20printing%20quality%2C%20orange%20and%20black%20design%20elements%2C%20modern%20aesthetic&width=600&height=700&seq=cat002&orientation=portrait',
    icon: 'ri-paint-brush-2-line',
  },
  {
    id: 3,
    title: 'Ekran Koruyucular',
    subtitle: 'Çizilmez, kırılmaz koruma',
    tag: 'Garantili',
    tagColor: 'bg-[#25D366]',
    image: 'https://readdy.ai/api/search-image?query=tempered%20glass%20screen%20protector%20installation%20on%20iPhone%20smartphone%2C%20clear%20perfect%20fit%20screen%20protection%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%20glass%20texture&width=600&height=700&seq=cat003&orientation=portrait',
    icon: 'ri-shield-check-line',
  },
  {
    id: 4,
    title: 'Şarj & Kablo',
    subtitle: 'Hızlı şarj, uzun ömür',
    tag: 'Orjinal',
    tagColor: 'bg-amber-500',
    image: 'https://readdy.ai/api/search-image?query=modern%20USB-C%20lightning%20charging%20cables%20and%20fast%20chargers%20for%20iPhone%20neatly%20arranged%20on%20dark%20surface%2C%20orange%20and%20white%20cables%2C%20premium%20quality%20accessories%2C%20clean%20product%20photography%20with%20dramatic%20lighting&width=600&height=700&seq=cat004&orientation=portrait',
    icon: 'ri-charging-pile-2-line',
  },
];

export default function ProductCategories() {
  return (
    <section id="urunler" className="py-20 md:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-3">Koleksiyonumuz</p>
          <h2
            className="text-white uppercase leading-none mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 7vw, 5rem)' }}
          >
            Ürün Kategorileri
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-md mx-auto">
            Aradığın her şey tek yerde.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href="#ozel-baski"
              className="group relative overflow-hidden rounded-2xl cursor-pointer aspect-[3/4] block"
            >
              {/* Background Image */}
              <img
                src={cat.image}
                alt={cat.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

              {/* Tag */}
              <div className={`absolute top-3 left-3 ${cat.tagColor} text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wide`}>
                {cat.tag}
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/15 border border-white/20 mb-2">
                  <i className={`${cat.icon} text-white text-sm`} />
                </div>
                <h3 className="text-white font-bold text-sm md:text-base leading-tight">{cat.title}</h3>
                <p className="text-white/50 text-xs mt-0.5">{cat.subtitle}</p>
              </div>

              {/* Hover Arrow */}
              <div className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-white text-sm" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
